export default {"src":"/_next/static/media/DVN.5652d136.svg","height":18,"width":18};